import { WorkOrderSwimlane } from "app/api/models";

export class WorkOrderUtils {

    public static getSwimlaneName(swimlane: WorkOrderSwimlane) {
        switch(swimlane) {
            case WorkOrderSwimlane.AwaitingCollection: return 'Awaiting Collection';
            case WorkOrderSwimlane.ThirdParty: return '3rd Party';
            case WorkOrderSwimlane.GoodsIn: return 'Goods In';
            case WorkOrderSwimlane.QaInspection: return 'QA Inspection';
            case WorkOrderSwimlane.ProofLoad: return 'Proof Load';
            case WorkOrderSwimlane.FirstStageBuild: return 'First Stage Build';
            case WorkOrderSwimlane.FinalBuild: return 'Final Build';
            case WorkOrderSwimlane.PressureTest: return 'Pressure Test';
            case WorkOrderSwimlane.FinalInspection: return 'Final Inspection';
            case WorkOrderSwimlane.ReadyForDispatch: return 'Ready for Dispatch';
            default: return WorkOrderSwimlane[+swimlane].toString();
        }
    }

    public static getSwimlaneColour(swimlane: WorkOrderSwimlane) {
        switch(swimlane) {
            case WorkOrderSwimlane.Backlog: return '#3b82f6';
            case WorkOrderSwimlane.ThirdParty: return '#d73bf6ff';
            case WorkOrderSwimlane.AwaitingCollection: return '#f59e0b';
            case WorkOrderSwimlane.GoodsIn: return '#8b5cf6';
            case WorkOrderSwimlane.QaInspection: return '#6366f1';
            case WorkOrderSwimlane.Gauging: return '#f59e0b';
            case WorkOrderSwimlane.ProofLoad: return '#8b5cf6';
            case WorkOrderSwimlane.FirstStageBuild: return '#14b8a6';
            case WorkOrderSwimlane.Calibration: return '#ec4899';
            case WorkOrderSwimlane.FinalBuild: return '#06b6d4';
            case WorkOrderSwimlane.PressureTest: return '#3b82f6';
            case WorkOrderSwimlane.FinalInspection: return '#10b981';
            case WorkOrderSwimlane.ReadyForDispatch: return '#f59e0b';
            case WorkOrderSwimlane.Dispatched: return '#64748b';
            default: return '#000000';
        }
    }
  
    public static getSwimlaneIcon(swimlane: WorkOrderSwimlane) {
        switch(swimlane) {
            case WorkOrderSwimlane.Backlog: return 'heroicons_outline:inbox';
            case WorkOrderSwimlane.AwaitingCollection: return 'heroicons_outline:building-storefront';
            case WorkOrderSwimlane.ThirdParty: return 'heroicons_outline:truck';
            case WorkOrderSwimlane.GoodsIn: return 'feather:package';
            case WorkOrderSwimlane.QaInspection: return 'heroicons_outline:clipboard-document-list';
            case WorkOrderSwimlane.Gauging: return 'feather:tool';
            case WorkOrderSwimlane.ProofLoad: return 'heroicons_outline:scale';
            case WorkOrderSwimlane.FirstStageBuild: return 'mat_outline:construction';
            case WorkOrderSwimlane.Calibration: return 'mat_outline:speed';
            case WorkOrderSwimlane.FinalBuild: return 'heroicons_outline:cog';
            case WorkOrderSwimlane.PressureTest: return 'mat_outline:water_drop';
            case WorkOrderSwimlane.FinalInspection: return 'heroicons_outline:clipboard-document-check';
            case WorkOrderSwimlane.ReadyForDispatch: return 'feather:package';
            case WorkOrderSwimlane.Dispatched: return 'feather:send';
            default: return '';
        }
    }

    public static getMachineColour = () => '#14b8a6';
    public static getMachineIcon = () => 'heroicons_outline:cog-8-tooth';
}